<template>
  <div class="home_head">
    <div class="head_left">
       <!-- 首页logo -->
      <!-- <img src="@/assets/img/logo.png" alt="" style="width:53px;height:53px">
      <img src="@/assets/img/logo2.png" alt="" style="width:53px;height:53px;padding-left: 5px;"> -->
      <!-- 首页标题 -->
      <!-- <p class="top_title" >宁夏人体器官捐献云上缅怀纪念平台</p> -->
      <img src="../assets/img/logo1.png" alt="">
    </div>
    <!-- 头部tab切换 -->
      <ul class="heat_ul">
        <li  v-for="(item,index) in hemeList" :key='index' :class="{selectedPic: selectedItemVal == item.id}" @click="gotab(item)">
         {{item.menu_name}}
        </li>

      </ul>
  </div>
</template>
<script>
import router from '../router'

export default {
    props: {
        headid: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            hemeList: [],
            selectedItemVal: ""
        };
    },
    watch: {
        // headid(n){
        //   console.log(n,'=======');
        //   this.selectedItemVal = n
        //   deep
        // },
        // selectedItemVal(n){
        //   console.log(n,'+++++++');
        // },
        // 监听用于设置动态class
        "headid": {
            deep: true,
            handler(val) {
                this.selectedItemVal = val;
            }
        },
        "selectedItemVal": {
            deep: true,
            handler(val) {
            }
        }
    },
    mounted() {
        this.getMenuList();
        this.selectedItemVal = this.headid;
    },
    methods: {
        // 头部tab跳转页面
        gotab(tab) {
            // this.selectedItemVal = tab.id;
        //  this.$router.push({
        //         path: tab.menu_url,
        //         query: {
        //             id: tab.id
        //         }
        //     });
      let routeUrl = this.$router.resolve({
                path: tab.menu_url,
                query: {
                    id: tab.id
                }
            });
            window.open(routeUrl.href,"_blank")

        },
        // 获取头部列表数据
        async getMenuList() {
            let res = await this.api.portal("menu.list", {
                pnid: "-1",
                // pnid: "1"
            });
            if (res) {
                this.hemeList = res.data.data;
                console.log(res,"好笨啊");
                this.$emit("headData", this.hemeList);
            }
        },
        navChecked(item) {
            // console.log('this.$route',this.$route);
            return item.menu_url == this.$route.path;
        },
    },
    components: { router }
}
</script>
<style lang="scss" scoped>
.home_head{
  width: 100%;
  display: flex;
  align-items: center;
  height: 90px;
  box-sizing: border-box;
  // background: rgba(81, 120, 113,0.6);
  background-color: #FFFFFF;
  // opacity: 0.4;
  z-index: 999;
  // position: fixed;
  // top: 0;
  // z-index: 999;
}
.head_left{
  display: flex;
  align-items: center;
  margin-left: 150px;

}
.top_title{
  width: 384px;
  height: 35px;
  font-size: 24px;
  font-family: SourceHanSerifSC-Bold-, SourceHanSerifSC-Bold;
  font-weight: normal;
  color: #000;
  font-weight: bolder;
  // color: #FFFFFF;
  line-height: 41px;
  margin-left: 10px;
}
.table_title{
  cursor:pointer;
}
.heat_ul{
  display: flex;
  font-size: 18px;
  width: 750px;
  justify-content: space-around;
  align-items: center;
  margin-left: 150px;
  color: #000;
  li{
    // width: 90px;
    // margin-left: 50px;
    cursor:pointer;
  }
  .selectedPic{
        color: #517871;
        font-size: 20px;
        font-weight: bolder;
      }
}

.el-menu-demo{
  width: 740px;
  margin-left: 50px;
}
.el-menu{
  background: none;
}

</style>